import { Typography } from "@mui/material"
import type { FC } from "react"

interface LinkedAccountsSectionProps {
  productId: number
}

// Stub: the full "Include Linked Accounts" feature ships in a follow-up ticket.
// For now, render only the Figma typography/body1 label so the slot is reserved
// in the pricing form and the schema field (`includeLinkedAccounts`) remains a
// non-interactive `false`.
export const LinkedAccountsSection: FC<LinkedAccountsSectionProps> = () => (
  <Typography variant='body1'>Include Linked Accounts</Typography>
)
